
import { Injectable } from "@angular/core";
import * as FileSaver from "file-saver";
import * as _ from "underscore";
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
// declare const ExcelJS: any;

@Injectable()
export class ExcelService {
  workbook: ExcelJS.Workbook;
  worksheet: any;
  constructor() { }

  public exportAsExcelFile(
    json: any[],
    excelFileName: string,
    colheaders: any[],
    gdpflag: any,
    downloadFile: boolean = true
  ) {
    const title = excelFileName;
    let newheaders: any = colheaders
    newheaders = _.without(colheaders, "Research Comments");
    const header = newheaders;
    const data = json;
    //Create workbook and worksheet
    let workbook = new ExcelJS.Workbook();
    let worksheet = workbook.addWorksheet("Sheet 1");

    if (gdpflag == true) {
      //gdpr
      let firstrow = worksheet.addRow([
        "GDPR alert! - This mandate has personally identifiable information of European Union data subject/s. You, as a data controller, must provide the data subject with the information as per Art. 14 of the GDPR."
      ]);
      firstrow.getCell(1).font = {
        name: "Arial",
        color: { argb: "ff0000" },
        family: 2,
        size: 11,
        bold: true
      };

      //Merge Cells
      worksheet.mergeCells(`A${firstrow.number}:F${firstrow.number}`);
    }

    //Add Header Row
    let headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      worksheet.getColumn(number).width = 30;
      cell.font = {
        name: "Arial",
        size: 11,
        bold: true
      };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "f3f3f3" }

      };

    });


    // Add Data and Conditional Formatting
    data.forEach(d => {
      let length = d.length;
      if (d[length - 1] == "New") {
        d.pop();
        d[length - 1] = "";
        let row = worksheet.addRow(d);
        row.eachCell((cell, number) => {
          worksheet.getColumn(number).width = 30;
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "adbcd2" }

          };

        });
      } else {
        if (d[length - 1] == "Old") {
          d.pop();
        }
        let row = worksheet.addRow(d);
      }
    });

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    //Generate Excel File with given name
    return workbook.xlsx.writeBuffer().then(data => {
      let blob = new Blob([data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });

      if(downloadFile) {
        FileSaver.saveAs(blob, excelFileName + ".xlsx");
        return null;
      }
      
      return blob;
    });
  }
}
